import React, { useEffect, useState } from 'react';
import { Modal, Button } from "react-bootstrap";
import { IoWarningOutline } from "react-icons/io5";
import { IconBaseProps } from "react-icons";
import styles from './SessionTimeoutModal.module.css';

const WarningIcon = IoWarningOutline as React.ComponentType<IconBaseProps>;

interface SessionTimeoutModalProps {
  show: boolean;
  onKeepAlive: () => void;
  onLogoutNow: () => void;
  expirationTime: number | null;
}

const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({ show, onKeepAlive, onLogoutNow, expirationTime }) => {
  const [timeLeft, setTimeLeft] = useState<number>(0);

  useEffect(() => {
    if (show && expirationTime) {
      setTimeLeft(Math.max(0, Math.ceil((expirationTime - Date.now()) / 1000)));

      const interval = setInterval(() => {
        const remainingStr = Math.max(0, Math.ceil((expirationTime - Date.now()) / 1000));
        setTimeLeft(remainingStr);
        if (remainingStr <= 0) {
          clearInterval(interval);
        }
      }, 1000);
      
      return () => clearInterval(interval);
    } else {
      setTimeLeft(0);
    }
  }, [show, expirationTime]);

  const mins = Math.floor(timeLeft / 60);
  const secs = timeLeft % 60;
  const minPart = mins > 0 ? `${mins} minute${mins !== 1 ? 's' : ''}` : '';
  const secPart = secs > 0 ? `${secs} second${secs !== 1 ? 's' : ''}` : '';
  const timeString = [minPart, secPart].filter(Boolean).join(' and ') || '0 seconds';

  return (
    <Modal
      show={show}
      centered
      dialogClassName={styles.sessionTimeoutDialog}
      contentClassName={styles.sessionTimeoutContent}
      backdropClassName={styles.sessionTimeoutBackdrop}
    >

      <Modal.Body className={styles.sessionTimeoutBody}>
        <div className={styles.sessionTimeoutIconContainer}>
          <WarningIcon size={48} className={styles.sessionTimeoutWarningIcon} />
        </div>
        <p className={styles.sessionTimeoutMessage}>
          Due to inactivity, this session will end in <span>{timeString}</span>
        </p>
      </Modal.Body>
      <Modal.Footer className={styles.sessionTimeoutFooter}>
        <Button className={styles.sessionTimeoutEndBtn} onClick={onLogoutNow}>
          End Session
        </Button>
        <Button className={styles.sessionTimeoutKeepAliveBtn} onClick={onKeepAlive}>
          Extend Session
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionTimeoutModal;
